import { observer } from 'mobx-react';
import React, { createRef } from 'react';
import 'reactflow/dist/style.css';
import {
	Callout,
	DirectionalHint,
	Icon,
	INavLink,
	INavLinkGroup,
	INavStyles,
	Nav,
	Stack,
	StackItem,
} from '@fluentui/react';
import { makeAutoObservable } from 'mobx';

interface ILocationContextMenuCtrlProps {
	state: LocationContextMenuCtrlState;
}

class LocationContextMenuCtrl extends React.Component<
	ILocationContextMenuCtrlProps,
	{}
> {
	private documentRef = createRef<HTMLDivElement>();
	private navStyles: Partial<INavStyles> = { root: { width: 300 } };

	render() {
		let navLinkGroups: INavLinkGroup[] = [
			{
				links: this.props.state.navLinks,
			},
		];

		return (
			<div className="locationContextMenuCtrl">
				<div
					ref={this.documentRef}
					onClick={() => {
						this.props.state.toggleCommands();
					}}
				>
					<Stack horizontal>
						<StackItem grow>{this.props.children}</StackItem>
						<StackItem>
							<Icon className="folderExpandChevron" iconName="ChevronDown" />
						</StackItem>
					</Stack>
				</div>

				{this.props.state.showCommands && (
					<Callout
						role="dialog"
						gapSpace={0}
						target={this.documentRef}
						isBeakVisible={false}
						directionalHint={DirectionalHint.bottomRightEdge}
						onDismiss={() => this.props.state.toggleCommands()}
					>
						<Stack>
							<Nav styles={this.navStyles} groups={navLinkGroups} />
						</Stack>
					</Callout>
				)}
			</div>
		);
	}
}

export default observer(LocationContextMenuCtrl);

export class LocationContextMenuCtrlState {
	public showCommands: boolean = false;
	public navLinks: INavLink[] = [];
	public loadNavLinks: () => INavLink[];

	constructor(loadNavLinks: () => INavLink[]) {
		this.loadNavLinks = loadNavLinks;
		makeAutoObservable(this);
	}

	public setNavLinks(navLinks: INavLink[]) {
		this.navLinks = navLinks;
	}

	public toggleCommands(show?: boolean) {
		if (show === undefined) {
			this.showCommands = !this.showCommands;
		} else {
			this.showCommands = show;
		}

		if (this.showCommands) {
			this.setNavLinks(this.loadNavLinks());
		}
	}
}
